<template>
    <div v-if="user">
        <va-page-header>

            <div slot="title">
                <span>{{ _('Users') }}</span>
            </div>

            <div slot="actions">
                <va-button v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager')" size="lg"
                    type="primary" @click.native="navigate('/users/new')">{{ _('NEW USER') }}
                </va-button>
            </div>

        </va-page-header>
        <va-row>
            <va-column style="display: flex; justify-content: flex-end;" :lg=" 12" :md="12" :sm="12" :xs="12">
                <va-input style="margin-bottom: 10px" @change="searchUser" v-model="searchString"
                    :placeholder="_('Search ' + currentTab.toString().toLowerCase() )" icon="search" showClean>
                </va-input>
            </va-column>
        </va-row>

        <va-row :gutter="12">
            <va-column :lg="12" :md="12" :sm="12">
                <va-tabs @changed="setCurrentTab" :cache-lifetime="cacheLifetime" style="min-height:680px !important;">

                    <va-tab v-if="user.get('roles').includes('admin')" :name="_('Admins')">
                        <users-list ref="adminTable" type="admin" />
                    </va-tab>

                    <va-tab v-if="user.get('roles').includes('admin')" :name="_('Managers')">
                        <users-list ref="managerTable" type="manager" />
                    </va-tab>

                    <va-tab v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager')"
                        :name="_('Users')">
                        <users-list ref="userTable" type="user" />
                    </va-tab>

                    <va-tab v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager')"
                        :name="_('Guests')">
                        <users-list ref="guestTable" type="guest" />
                    </va-tab>

                </va-tabs>
            </va-column>
        </va-row>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    import UsersList from './UsersList.vue'

    export default {

        components: {
            UsersList
        },

        data() {
            return {
                cacheLifetime: 10,
                searchString: '',
                currentTab: '',
            }
        },


        computed: {
            ...mapGetters(["user"]),

        },


        methods: {

            setCurrentTab(e) {
                if (e && e.tab && e.tab.header) {
                    this.currentTab = e.tab.header
                }
            },

            navigate(to) {
                this.$router.push(to);
            },

            searchUser() {
                if (this.currentTab == 'Admins') {
                    this.$refs.adminTable.searchUser(this.searchString)
                } else if (this.currentTab == 'Managers') {
                    this.$refs.managerTable.searchUser(this.searchString)
                } else if (this.currentTab == 'Users') {
                    this.$refs.userTable.searchUser(this.searchString)
                } else if (this.currentTab == 'Guests') {
                    this.$refs.guestTable.searchUser(this.searchString)
                }
            }

        },


        mounted() {

        }
    };
</script>

<style>
</style>